export const ModalTheme = {
  baseStyle: {
    dialog: {
      borderRadius: '10px',
      textAlign: 'center',
      marginX: 6,
    },
    header: {
      color: 'brand.cyan',
      fontSize: '22px',
      fontWeight: 'medium',
      paddingTop: { base: 9, lg: 12 },
      lineHeight: '110%',
      px: 8,
    },
    body: {
      lineHeight: '120%',
      px: 8,
    },
    footer: {
      px: 8,
      paddingBottom: { base: 9, lg: 12 },
      justifyContent: 'center'
    }
  },
  sizes: {
    'full': {
      overlay: { background: 'transparent' },
      dialog: { p: 0, m: 0, h: '100%' },
    },
  },
  defaultProps: {
    isCentered: true,
    size: 'lg'
  }
}